import axios from "axios";
import { apiBaseUrl } from "@/apis/appconst";

// 🔹 Add or Update Client
export async function addClient(client_data) {
  try {
    const fd = new FormData();
    fd.append("client_data", btoa(JSON.stringify(client_data)));

    const response = await axios.post(`${apiBaseUrl}client/add_client`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("addClient error:", error);
    return { status: false, type: "danger", success: "Failed to save client" };
  }
}

// 🔹 Get Client Report (Dashboard Stats)
export async function getClientReport(user_cre_by = "") {
  try {
    const fd = new FormData();
    fd.append("user_cre_by", user_cre_by);

    const response = await axios.post(`${apiBaseUrl}client/get_client_report`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    console.error("getClientReport error:", error);
    return { status: false, type: "danger", success: "Failed to fetch client report" };
  }
}


// 🔹 Get Clients
export async function getClients(user_cre_by, status = "", page_no = 0, search_key = "") {
  try {
    const fd = new FormData();
    fd.append("user_cre_by", user_cre_by);
    fd.append("status", status);
    fd.append("page_no", page_no);
    fd.append("search_key", search_key);

    const response = await axios.post(`${apiBaseUrl}client/get_clients`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("getClients error:", error);
    return { status: false, type: "danger", success: "Failed to fetch clients" };
  }
}

// 🔹 Delete Client
export async function deleteClient(user_id) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);

    const response = await axios.post(`${apiBaseUrl}client/delete_client`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("deleteClient error:", error);
    return { status: false, type: "danger", success: "Failed to delete client" };
  }
}

// 🔹 Get Client By ID
export async function getClientById(user_id) {
  try {
    const fd = new FormData();
    fd.append("user_id", user_id);

    const response = await axios.post(`${apiBaseUrl}client/get_client_by_id`, fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  } catch (error) {
    console.error("getClientById error:", error);
    return { status: false, type: "danger", success: "Failed to fetch client details" };
  }
}

export async function importClients(file, user_id) {
  try {
    const fd = new FormData();
    fd.append("user_cre_by", user_id);
    fd.append("file", file); // single file only

    const response = await axios.post(
      `${apiBaseUrl}client/import_clients`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    );

    return response.data;
  } catch (error) {
    console.error("importClients error:", error);
    return {
      status: false,
      type: "danger",
      success: "Failed to import clients",
    };
  }
}

export async function exportClients(user_id) {
  try {
    const url = `${apiBaseUrl}client/export_clients?user_id=${user_id}`;

    const response = await axios.get(url, {
      responseType: "blob", // important for download
    });

    // Create a download link
    const blob = new Blob([response.data], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "clients_export.csv";
    link.click();

    return { status: true };
  } catch (error) {
    console.error("exportClients error:", error);
    return {
      status: false,
      type: "danger",
      success: "Failed to export clients",
    };
  }
}
export async function downloadClientSample() {
  try {
    const url = `${apiBaseUrl}client/download_client_sample`;

    const response = await axios.get(url, {
      responseType: "blob",
    });

    const blob = new Blob([response.data], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "client_import_sample.csv";
    link.click();

    return { status: true };
  } catch (error) {
    console.error("downloadClientSample error:", error);
    return {
      status: false,
      type: "danger",
      success: "Failed to download sample",
    };
  }
}


